import './App.css';
import React, { lazy, Suspense } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

// 求人
import Top from './pages/top/index';
import WorksRecruit from './pages/recruit/recruit/index';
import Contact from './pages/contact/index';

// 認証
import CompanySignIn from './salon/auth/login/0-signin';
import CompanyLogin from './salon/auth/login/1-login';
import CompanyConfirm from './salon/auth/login/2-confirm';
import CompanyReset from './salon/auth/login/3-reset';
import CompanyAction from './salon/auth/login/4-action';
import JudgeSignIn from './salon/auth/judge/index';

// サービス
import WorksService from './salon/desktop/index';
import AuthGate from './salon/desktop/authGate';
import WorksCallback from './salon/desktop/9.callback/index';

// 学校
import SchoolService from './school/index';
import SchoolAuthGate from './school/SchoolAuthGate';

// 使い方マニュアル(学校側・学生側)
import SchoolManual from './manual/school/index';
import StudentAppManual from './manual/student/index';
import SalonManual from './manual/salon/index';
import GuidanceYicManual from './manual/guidance-yic/index';

// メディア
import Media0001 from './pages/media/article/0001';
import Media0002 from './pages/media/article/0002';
import Media0003 from './pages/media/article/0003';
import Media0004 from './pages/media/article/0004';
import Media0005 from './pages/media/article/0005';
import Media0006 from './pages/media/article/0006';
import Media0007 from './pages/media/article/0007';

// その他のページ
import TermsApp from './pages/document/terms/app/index';
import TermsService from './pages/document/terms/service/index';
import PolicyApp from './pages/document/policy/app/index';
import PolicyService from './pages/document/policy/service/index';
import NotFoundPage from './pages/404/index';

import NewwSite from './pages/home/index';
import SchoolLp from './pages/school/index';
import About from './pages/about/index';

// 性格診断（誰でも受けられる公開ページ）
import PersonalityHome from './pages/personality/index';
import PersonalityQuestion from './pages/personality/question/index';
import PersonalityResult from './pages/personality/result/index';
import PersonalityAnalytics from './pages/personality/analytics/index';

// My Card 公開プロフィール
import StudentCardPage from './pages/student/profile/index';

import SchoolEntry from './school/schoolEntry/index';

import GuidancePage from './pages/guidance/index';

// 参謀（ガイダンス開催事業者）
import SanpouLogin from './sanpou/auth/login/index';
import SanpouPage from './sanpou/index';

// onetime は開発/管理用フラグが立った時のみ lazy load
const isOnetimeEnabled = process.env.REACT_APP_ENABLE_ONETIME === 'true';

const Onetime = isOnetimeEnabled ? lazy(() => import('./onetime/operations/ai-scoring/index')) : null;
const Analytics = isOnetimeEnabled ? lazy(() => import('./onetime/analysis/etl-export/analytics')) : null;
const FirstView = isOnetimeEnabled ? lazy(() => import('./onetime/analysis/pv-engagement/firstview')) : null;
const RecruitScore = isOnetimeEnabled ? lazy(() => import('./onetime/analysis/recruit-quality/recruitScore')) : null;
const BehaviorLogs = isOnetimeEnabled ? lazy(() => import('./onetime/operations/recommendation-pipeline/behaviorLogs')) : null;
const Recommendation = isOnetimeEnabled ? lazy(() => import('./onetime/operations/recommendation-pipeline/recommendation')) : null;
const RecruitRankingLocal = isOnetimeEnabled ? lazy(() => import('./onetime/operations/ranking/recruit-ranking-local/index')) : null;
const AiParameters = isOnetimeEnabled ? lazy(() => import('./onetime/operations/ai-scoring/aiParameters')) : null;
const InsteadUpdate = isOnetimeEnabled ? lazy(() => import('./onetime/operations/search-index-admin/insteadUpdate')) : null;
const RecruitsData = isOnetimeEnabled ? lazy(() => import('./onetime/analysis/recruit-quality/recruitsData')) : null;
const SendingList = isOnetimeEnabled ? lazy(() => import('./onetime/operations/school-sending/sendingList')) : null;
const AddSchoolToSearchIndex = isOnetimeEnabled ? lazy(() => import('./onetime/operations/school-sending/addSchoolToSearchIndex')) : null;
const GuidanceSetting = isOnetimeEnabled ? lazy(() => import('./onetime/operations/guidance-admin/guidanceSetting')) : null;
const GuidanceList = isOnetimeEnabled ? lazy(() => import('./onetime/operations/guidance-admin/guidanceList')) : null;
const GuidanceArchive = isOnetimeEnabled ? lazy(() => import('./onetime/operations/guidance-admin/guidanceArchive')) : null;
const GuidanceAdd = isOnetimeEnabled ? lazy(() => import('./onetime/operations/guidance-admin/guidanceAdd')) : null;
const CtrAnalytics = isOnetimeEnabled ? lazy(() => import('./onetime/analysis/pv-engagement/ctr_analytics')) : null;
const GuidanceAnalytics = isOnetimeEnabled ? lazy(() => import('./onetime/analysis/guidance/guidance-analytics')) : null;
const PamphletFix = isOnetimeEnabled ? lazy(() => import('./onetime/operations/pamphlet/index')) : null;
const TargetFix = isOnetimeEnabled ? lazy(() => import('./onetime/operations/target/index')) : null;
const StoreSearch = isOnetimeEnabled ? lazy(() => import('./onetime/operations/store-search/index')) : null;
const PostsList = isOnetimeEnabled ? lazy(() => import('./onetime/analysis/posts-review/postsList')) : null;
const CtrImageRanking = isOnetimeEnabled ? lazy(() => import('./onetime/analysis/pv-engagement/ctrImageRanking')) : null;

function App() {
  return (
    <>
    <Router>
      <Suspense fallback={null}>
      <Routes>

        {isOnetimeEnabled && Onetime && <Route path="/onetime" element={<Onetime />} />}
        {isOnetimeEnabled && Analytics && <Route path="/onetime/analytics" element={<Analytics />} />}
        {isOnetimeEnabled && FirstView && <Route path="/onetime/firstview" element={<FirstView />} />}
        {isOnetimeEnabled && RecruitScore && <Route path="/onetime/recruitscore" element={<RecruitScore />} />}
        {isOnetimeEnabled && BehaviorLogs && <Route path="/onetime/behaviorlogs" element={<BehaviorLogs />} />}
        {isOnetimeEnabled && Recommendation && <Route path="/onetime/recommendation" element={<Recommendation />} />}
        {isOnetimeEnabled && RecruitRankingLocal && <Route path="/onetime/recruit-ranking-local" element={<RecruitRankingLocal />} />}
        {isOnetimeEnabled && AiParameters && <Route path="/onetime/aiparameters" element={<AiParameters />} />}
        {isOnetimeEnabled && InsteadUpdate && <Route path="/onetime/insteadupdate" element={<InsteadUpdate />} />}
        {isOnetimeEnabled && RecruitsData && <Route path="/onetime/recruitsdata" element={<RecruitsData />} />}
        {isOnetimeEnabled && SendingList && <Route path="/onetime/sendinglist" element={<SendingList />} />}
        {isOnetimeEnabled && AddSchoolToSearchIndex && <Route path="/onetime/addschooltosearchindex" element={<AddSchoolToSearchIndex />} />}
        {isOnetimeEnabled && GuidanceSetting && <Route path="/onetime/guidancesetting" element={<GuidanceSetting />} />}
        {isOnetimeEnabled && GuidanceList && <Route path="/onetime/guidancelist" element={<GuidanceList />} />}
        {isOnetimeEnabled && GuidanceArchive && <Route path="/onetime/guidancearchive" element={<GuidanceArchive />} />}
        {isOnetimeEnabled && GuidanceAdd && <Route path="/onetime/guidanceadd" element={<GuidanceAdd />} />}
        {isOnetimeEnabled && CtrAnalytics && <Route path="/onetime/ctranalytics" element={<CtrAnalytics />} />}
        {isOnetimeEnabled && GuidanceAnalytics && <Route path="/onetime/guidanceanalytics" element={<GuidanceAnalytics />} />}
        {isOnetimeEnabled && PamphletFix && <Route path="/onetime/pamphletfix" element={<PamphletFix />} />}
        {isOnetimeEnabled && TargetFix && <Route path="/onetime/targetfix" element={<TargetFix />} />}
        {isOnetimeEnabled && StoreSearch && <Route path="/onetime/storesearch" element={<StoreSearch />} />}
        {isOnetimeEnabled && PostsList && <Route path="/onetime/postslist" element={<PostsList />} />}
        {isOnetimeEnabled && CtrImageRanking && <Route path="/onetime/ctrimageranking" element={<CtrImageRanking />} />}

        {/* 検索サイト */}
        <Route exact path="/" element={<Top />} />
        <Route exact path="/search" element={<Top />} />
        <Route exact path="/recruit/:id" element={<WorksRecruit />} />

        {/* WEBページ */}
        <Route exact path="/company" element={<NewwSite />} />
        <Route exact path="/school" element={<SchoolLp />} />
        <Route exact path="/contact" element={<Contact />} />
        <Route exact path="/about" element={<About />} />
        <Route path="/schoolEntry" element={<SchoolEntry />} />

        {/* 性格診断（誰でも受けられる公開ページ） */}
        <Route exact path="/personality" element={<PersonalityHome />} />
        <Route exact path="/personality/question" element={<PersonalityQuestion />} />
        <Route exact path="/personality/result/:type" element={<PersonalityResult />} />
        <Route exact path="/personality/analytics" element={<PersonalityAnalytics />} />

        {/* My Card 公開プロフィール */}
        <Route exact path="/student/:slug" element={<StudentCardPage />} />

        {/* 認証 */}
        <Route exact path="/company/login" element={<CompanyLogin />} />
        <Route exact path="/company/signin" element={<CompanySignIn />} />
        <Route exact path="/company/reset" element={<CompanyReset />} />
        <Route exact path="/company/action" element={<CompanyAction />} />
        <Route exact path="/company/confirm" element={<CompanyConfirm />} />
        <Route exact path="/company/judge-signin" element={<JudgeSignIn />} />


        {/* サービス側 */}
        <Route
          path="/service/*"
          element={
            <AuthGate>
              <WorksService />
            </AuthGate>
          }
        />
        <Route exact path="/service/callback" element={<WorksCallback />} />

        {/* 使い方マニュアル(ログイン不要。学校・学生どちらもスマホ・PCから読めるようにする) */}
        <Route path="/manual/school" element={<SchoolManual />} />
        <Route exact path="/manual/student" element={<StudentAppManual />} />
        <Route path="/manual/salon" element={<SalonManual />} />
        <Route path="/manual/guidance-yic" element={<GuidanceYicManual />} />

        {/* 学校側 */}
        <Route
          path="/school/service/*"
          element={
            <SchoolAuthGate>
              <SchoolService />
            </SchoolAuthGate>
          }
        />

        {/* メディア */}
        <Route exact path="/media/0001" element={<Media0001 />} />
        <Route exact path="/media/0002" element={<Media0002 />} />
        <Route exact path="/media/0003" element={<Media0003 />} />
        <Route exact path="/media/0004" element={<Media0004 />} />
        <Route exact path="/media/0005" element={<Media0005 />} />
        <Route exact path="/media/0006" element={<Media0006 />} />
        <Route exact path="/media/0007" element={<Media0007 />} />

        {/* ガイダンス */}
        <Route path="/guidance-gunbi" element={<GuidancePage school="群馬県美容専門学校" />} />
        <Route path="/guidance-haribi" element={<GuidancePage school="ハリウッドワールド美容専門学校" />} />
        {/* 順位付けの学校は rankCount を info/guidance の rankCount と合わせる */}
        <Route path="/guidance-yic" element={<GuidancePage school="YICビューティモード専門学校" rankCount={6} />} />
        <Route path="/guidance-universal" element={<GuidancePage school="ユニバーサル美容専門学校" rankCount={8} />} />

        {/* 参謀（ガイダンス開催事業者） */}
        <Route path="/sanpou/login" element={<SanpouLogin />} />
        <Route path="/sanpou" element={<SanpouPage />} />

        {/* その他のページ */}
        <Route exact path="/terms-app" element={<TermsApp />} />
        <Route exact path="/terms-service" element={<TermsService />} />
        <Route exact path="/policy-app" element={<PolicyApp />} />
        <Route exact path="/policy-service" element={<PolicyService />} />
        <Route path="*" element={<NotFoundPage />} />

      </Routes>
      </Suspense>
    </Router>
    </>
  );
}

export default App;
